import React, { useMemo } from 'react'
import styled, { css } from 'styled-components'

import { useApplicationContext } from '../../contexts'
import { useLabelStyle } from '../../hooks'
import { BlockTitle } from '../BlockTitle'
import MobileField from './MobileField'
import type { FieldInputProps } from './types'
import WebsiteField from './WebsiteField'

const SCxFieldContainer = styled.div`
    width: 100%;
    height: 100%;
    padding: var(--block-padding);
`

const SCxLayout = styled.div<{ direction?: 'column' | 'row' }>`
    display: flex;
    ${({ direction }) =>
        direction === 'row'
            ? css`
                  flex-direction: row;
                  align-items: flex-start;
                  gap: 16px;
              `
            : css`
                  flex-direction: column;
                  gap: 0px;
              `}
`

const currentDirection = 'column'

export const FieldInput = React.forwardRef<HTMLDivElement, FieldInputProps>((props, ref) => {
    const { config, style } = props
    const { required, showTitle, title, inputType, breakPoint } = config
    const { isMobile } = useApplicationContext()
    const labelStyle = useLabelStyle(breakPoint?.design?.labelColor)
    const fontFamily = breakPoint?.font?.fontFamily
    return (
        <SCxFieldContainer ref={ref} style={style}>
            {useMemo(
                () => (
                    <SCxLayout direction={currentDirection} style={{ height: inputType === 'calendar' ? '100%' : 'auto' }}>
                        {showTitle && (
                            <BlockTitle
                                title={title}
                                required={required}
                                style={{
                                    fontFamily,
                                    width: 'calc(100% - 8px)',
                                    ...labelStyle
                                }}
                                direction={currentDirection}
                            />
                        )}
                        {isMobile ? <MobileField {...props} /> : <WebsiteField {...props} />}
                    </SCxLayout>
                ),
                [inputType, showTitle, title, required, fontFamily, labelStyle, isMobile, props]
            )}
        </SCxFieldContainer>
    )
})
